import styled from 'styled-components';
import { color, fontSize, fontWeight, spacing } from 'theme';

export const StyledGrid = styled.div`
  &.loading {
    opacity: 0.2;
    pointer-events: none;
  }
  .masonry-grid {
    display: flex;
    margin-left: -${spacing('xl')}; /* gutter size offset */
    width: auto;
  }
  .masonry-column {
    padding-left: ${spacing('xl')}; /* gutter size */
    background-clip: padding-box;

    &:empty {
      display: none;
    }

    > div {
      margin-bottom: ${spacing('xl')};
    }
  }
`;

export const StyledGridSeparator = styled.div`
  font-size: ${fontSize('xs')};
  font-weight: ${fontWeight('medium')};
  line-height: 1.33;
  text-transform: uppercase;
  text-align: center;
  padding-top: ${spacing('xl')};
  padding-bottom: ${spacing('xl')};
  margin-bottom: ${spacing('xl')};
  display: flex;
  align-items: center;

  span {
    padding-right: ${spacing('md')};
    padding-left: ${spacing('md')};
  }

  &::before,
  &::after {
    content: '';
    flex-grow: 1;
    height: 1px;
    background-color: ${color('midnight_200')};
  }
`;
